<loader [loading]="isLoading"></loader>

<!-- No Notes message -->
<div *ngIf="notes?.length == 0 && !isLoading"
     style="text-align: center;padding: 60px;">
  <h4 style="margin-bottom: 20px;">Report doesn't have any Notes</h4>
  <button [disabled]="createDeleteFlag" class="btn btn-rbv" (click)="onCreateLink()">Create New Note</button>
</div>

<!-- List of Link -->
<div *ngIf="notes?.length > 0 && !isLoading">
  <report-note *ngFor="let note of notes | orderBy: ['ORDER']; let i = index"
               [note]="note" [reportId]="currentReport.ID" [index] = 'i' [length] ="notes.length"
               (onDeleted)="onNoteDeleted(i)" (onOrderUp)="onOrderUp(note, i)" (onOrderDown)="onOrderDown(note, i)"></report-note>

  <div style="text-align: center;padding: 20px;">
    <button [disabled]="createDeleteFlag" class="btn btn-rbv" (click)="onCreateLink()">Create New Note</button>
  </div>
</div>
